import request from '@/utils/request3'
import store from '@/store'
const serviceName = store.state.serviceName.workOrder

// 查询行业类型列表
export function getIndustryList() {
    return request({
        url: serviceName + '/dim/dim_table_char/industry',
        method: 'post'
    })
}

// 查询所有销售代表
export function getSalesList() {
    return request({
        url: serviceName + '/user/queryAllSales',
        method: 'post'
    })
}

// 查询部门列表（维表）
export function getAllDepartments() {
    return request({
        url: serviceName + '/dim/dim_table_char/department',
        method: 'post'
    })
}